export const detailCodes = {
    namespaced: true,
    state: {
        detailCodes: {
            jobCodes: null,
            jobTypeCodes: null,
            salaryTypeCodes: null,
            certificateTypeCodes: null,
            organDutyAreaCodes: null,
            reasonCodes: null,
            carUsageTypeCodes: null,
            carPossessTypeCodes: null,
            carStateCodes: null,
            carMaintenanceTypeCodes: null,
            chargeCreateStandardCodes: null,
            payMethodCodes: null,
            depositBankCodes: null,
            smsCategoryCodes: null,
            guardianRelationshipCodes: null,
            religionCodes: null,
            guardianRelationCodes: null,
            seniorRelationCodes: null,
            longtermcareGradeCodes: null,
            deputyRelationshipCodes: null,
            personChargeTypeCodes: null,
            writeReasonCode: null,
            contractStateCodes: null,
            legendFormBoxCodes: null,
            legendFormClassCodes: null,
            openScopeCodes: null,
            staffSelectTypeCodes: null,
            retirementReasonCodes: null,
            ltcareServiceTypeCodes: null,
            reportReasonTypeCodes: null,
            recipientStatusCodes: null,
            cancelReasonCodes: null,
            careServiceTypeCodes: null,
            homeServiceTypeCodes: null,
            officeCheckMethodTypeCodes: null,
            checkDeviceSetupOrganTypeCodes: null,
            payKindTypeCodes: null,
            distressTypeCodes: null,
            evalLocationTypeCodes: null,
            optionServiceTypeCodes: null,
            suadeContractPostponeReasonCodes: null,
            familyCareRelationCodes: null,
            inquiryCodes: null,
            certificateItemsCodes: null,
            salaryNumberCodes: null,
            salaryFrequencyTypeCodes: null,
            medicineTypeCodes: null,
            useMethodCodes: null,
            disinfectMethodCodes: null,
            counselMethodCodes: null,
            dosageMethodCodes: null,
            keepMethodCodes: null,
            vacationTypeCodes: null,
            holidayTypeCodes: null,
            vacationApplyStandardCodes: null,
            annualCalcDecimalCodes: null,
            annualPromotionCodes: null,
            approvalInserviceLifeTypeCodes: null,
            approvalLineTypeCodes: null,
            approvalMethodTypeCodes: null,
            approvalAgreeProgressCodes: null,
            accountTypeCodes: null,
            depositOwnerTypeCodes: null,
            vacationUseMethodCodes: null,
            approvalImportantTypeCodes: null,
            payCancelRefundMethodCodes: null,
            openRangeVisibilityCodes: null,
            sendMethodTypeCodes: null,
            activeStateCodes: null,
            inflowRouteCodes: null,
            counselClassTypeCodes: null,
            koreaEmployClassCodes: null,
            snsAttendStateCodes: null,
            messageReplaceCodes: null,
            meetingTypeCodes: null,

            // AUTH
            sidoCodes: null,
            itcareAgencyTypeCodes: null,
            businessTypeCodes: null,
            businessConditionCodes: null,
            busunessEventCodes: null,
        }
    },
    mutations: {
        DETAIL_CODES(state, data) {
            switch (data.GCode) {
                case 104: // 사업자유형 (AUTH)
                    state.detailCodes['businessTypeCodes'] = data.data;
                    break
                case 106: // 시도코드 (AUTH)
                    state.detailCodes['sidoCodes'] = data.data;
                    break
                case 107: // 사업업태 (AUTH)
                    state.detailCodes['businessConditionCodes'] = data.data;
                    break
                case 108: // 사업종목 (AUTH)
                    state.detailCodes['busunessEventCodes'] = data.data;
                    break
                case 291: // 장기요양기관유형 (AUTH)
                    state.detailCodes['itcareAgencyTypeCodes'] = data.data;
                    break
                case 113: // 종교코드
                    state.detailCodes['religionCodes'] = data.data;
                    break
                case 116: // 직원유형
                    state.detailCodes['jobTypeCodes'] = data.data;
                    break
                case 117: // 계약상태
                    state.detailCodes['contractStateCodes'] = data.data;
                    break
                case 120: // 급여유형
                    state.detailCodes['salaryTypeCodes'] = data.data;
                    break
                case 129: // 산업분류
                    state.detailCodes['jobCodes'] = data.data;
                    break
                case 130: // 자격구분
                    state.detailCodes['certificateTypeCodes'] = data.data;
                    break
                case 131: // 기관직무분야
                    state.detailCodes['organDutyAreaCodes'] = data.data;
                    break
                case 132: // 자격종목코드
                    state.detailCodes['certificateItemsCodes'] = data.data;
                    break
                case 143: // 퇴직사유
                    state.detailCodes['retirementReasonCodes'] = data.data;
                    break;
                case 197: // 회원탈퇴사유
                    state.detailCodes['reasonCodes'] = data.data;
                    break
                case 210: // 납입방법코드
                    state.detailCodes['payMethodCodes'] = data.data;
                    break
                case 216: // SMS카테고리코드
                    state.detailCodes['smsCategoryCodes'] = data.data;
                    break
                case 218: // 범례서식함구분코드
                    state.detailCodes['legendFormBoxCodes'] = data.data;
                    break
                case 219: // 범례서식분류코드
                    state.detailCodes['legendFormClassCodes'] = data.data;
                    break
                case 223: // 부가서비스구분코드
                    state.detailCodes['optionServiceTypeCodes'] = data.data;
                    break
                case 227: // 납입은행코드
                    state.detailCodes['depositBankCodes'] = data.data;
                    break
                case 229: // 재가서비스유형코드
                    state.detailCodes['homeServiceTypeCodes'] = data.data.slice(2, 3);
                    break
                case 231: // SNS공개범위코드
                    state.detailCodes['openScopeCodes'] = data.data;
                    break
                case 232: // SNS신고이유구분코드
                    state.detailCodes['reportReasonTypeCodes'] = data.data;
                    break
                case 233: // 휴가분류코드
                    state.detailCodes['vacationTypeCodes'] = data.data;
                    break
                case 244: // 청구생성기준코드
                    state.detailCodes['chargeCreateStandardCodes'] = data.data;
                    break
                case 245: // 활동상태
                    state.detailCodes['activeStateCodes'] = data.data;
                    break
                case 250: // 롱텀케어 등급정보
                    state.detailCodes['longtermcareGradeCodes'] = data.data;
                    break
                case 252: // 보호자관계코드
                    state.detailCodes['guardianRelationshipCodes'] = data.data;
                    break
                case 253: // 대리인관계코드
                    state.detailCodes['deputyRelationshipCodes'] = data.data;
                    break
                case 256: // 본인부담금률
                    state.detailCodes['personChargeTypeCodes'] = data.data;
                    break
                case 258: // 출근체크방법구분코드
                    state.detailCodes['officeCheckMethodTypeCodes'] = data.data;
                    break
                case 259: // 체크기기설치기관구분코드
                    state.detailCodes['checkDeviceSetupOrganTypeCodes'] = data.data;
                    break
                case 260: // 수급자 상태코드
                    state.detailCodes['recipientStatusCodes'] = data.data;
                    break
                case 261: // 수급자 계약 해지 또는 취소 사유 코드
                    state.detailCodes['cancelReasonCodes'] = data.data;
                    break
                case 262: // 차량용도
                    state.detailCodes['carUsageTypeCodes'] = data.data.slice(2, 3);
                    break
                case 263: // 차량소유
                    state.detailCodes['carPossessTypeCodes'] = data.data;
                    break
                case 264: // 차량상태
                    state.detailCodes['carStateCodes'] = data.data;
                    break
                case 265: // 차량정비구분
                    state.detailCodes['carMaintenanceTypeCodes'] = data.data;
                    break
                case 253: // 시니어관계코드
                    state.detailCodes['seniorRelationCodes'] = data.data;
                    break
                case 276: // 직원선택구분코드
                    data.data.splice(3, 1)
                    state.detailCodes['staffSelectTypeCodes'] = data.data;
                    break
                case 277: // 회의참석코드
                    state.detailCodes['snsAttendStateCodes'] = data.data;
                    break
                case 278: // 급여종류
                    state.detailCodes['payKindTypeCodes'] = data.data;
                    break
                case 284: // 가족요양관계코드
                    state.detailCodes['familyCareRelationCodes'] = data.data;
                    break
                case 293: //수급보류 코드
                    state.detailCodes['suadeContractPostponeReasonCodes'] = data.data;
                    break
                case 298: // 요양보호사 급여유형 코드
                    state.detailCodes['careServiceTypeCodes'] = data.data;
                    break
                case 307: // 급여제공계획 사유서 작성사유
                    state.detailCodes['writeReasonCode'] = data.data;
                    break
                case 308: //고충상담구분코드
                    state.detailCodes['distressTypeCodes'] = data.data;
                    break
                case 310: // 서비스문의코드
                    state.detailCodes['inquiryCodes'] = data.data;
                    break
                case 311: // 수가코드
                    state.detailCodes['salaryNumberCodes'] = data.data;
                    break
                case 316: // 계좌구분코드
                    state.detailCodes['accountTypeCodes'] = data.data;
                    break
                case 315: // 예금주구분코드
                    state.detailCodes['depositOwnerTypeCodes'] = data.data;
                    break
                case 327: // 결재선유형코드
                    state.detailCodes['approvalLineTypeCodes'] = data.data;
                    break
                case 328: // 결재방법유형코드
                    state.detailCodes['approvalMethodTypeCodes'] = data.data;
                    break;
                case 329: // 결재합의자진행방식코드
                    state.detailCodes['approvalAgreeProgressCodes'] = data.data;
                    break;
                case 330: // 보존연한구분코드
                    state.detailCodes['approvalInserviceLifeTypeCodes'] = data.data;
                    break
                case 332: // 중요도구분코드
                    state.detailCodes['approvalImportantTypeCodes'] = data.data;
                    break
                case 336: // 휴가적용기준코드
                    state.detailCodes['vacationApplyStandardCodes'] = data.data;
                    break
                case 337: // 연차계산소수자리코드
                    state.detailCodes['annualCalcDecimalCodes'] = data.data;
                    break
                case 339: // 연차촉진코드
                    state.detailCodes['annualPromotionCodes'] = data.data;
                    break
                case 344: // 휴일유형코드
                    state.detailCodes['holidayTypeCodes'] = data.data;
                    break
                case 347: // 구분코드
                    state.detailCodes['medicineTypeCodes'] = data.data;
                    break
                case 348: // 사용방식코드
                    state.detailCodes['useMethodCodes'] = data.data;
                    break
                case 349: // 소독방법코드
                    state.detailCodes['disinfectMethodCodes'] = data.data;
                    break
                case 350: // 투약방법
                    state.detailCodes['dosageMethodCodes'] = data.data;
                    break
                case 351: // 보관방법
                    state.detailCodes['keepMethodCodes'] = data.data;
                    break
                case 353: // 휴가사용방법코드
                    state.detailCodes['vacationUseMethodCodes'] = data.data;
                    break
                case 356: // 유입경로코드
                    state.detailCodes['inflowRouteCodes'] = data.data;
                    break
                case 368: // 장기요양서비스유형코드
                    state.detailCodes['ltcareServiceTypeCodes'] = data.data.slice(0, 3);
                    break
                case 371: // 캘린더 공개범위설정
                    state.detailCodes['openRangeVisibilityCodes'] = data.data;
                    break;
                case 376: // 급여횟수구분코드
                    state.detailCodes['salaryFrequencyTypeCodes'] = data.data;
                    break
                case 387: // 검사장소구분코드
                    state.detailCodes['evalLocationTypeCodes'] = data.data;
                    break
                case 396: // 취소환불방법코드
                    state.detailCodes['payCancelRefundMethodCodes'] = data.data;
                    break
                case 398: // 전달방법코드
                    state.detailCodes['sendMethodTypeCodes'] = data.data;
                    break
                case 406: // 상담방법
                    state.detailCodes['counselMethodCodes'] = data.data;
                    break
                case 407: // 상담분류코드
                    state.detailCodes['counselClassTypeCodes'] = data.data;
                    break
                case 434: // 고용직종부호
                    state.detailCodes['koreaEmployClassCodes'] = data.data;
                    break
                case 470: // 메시지치환코드
                    state.detailCodes['messageReplaceCodes'] = data.data;
                    break
                case 473: //회의록구분코드
                    state.detailCodes['meetingTypeCodes'] = data.data;
                    break
            }
        },
    },
    actions: {
        DETAIL_CODES({ commit }, payload) {
            commit('DETAIL_CODES', payload)
        }
    },
    getters: {
        RELIGION_CODES: state => { // 113 종교코드
            return state.detailCodes.religionCodes
        },
        JOB_TYPE_CODES: state => { // 116 직원유형
            return state.detailCodes.jobTypeCodes
        },
        // JOB_TYPE_FILTER: state => { // 116 직원유형 필터
        //     if(state.detailCodes.jobTypeCodes) {
        //         return state.detailCodes.jobTypeCodes.slice(0, 4)
        //     }
        // },
        SALARY_TYPE_CODES: state => { // 120 급여유형
            return state.detailCodes.salaryTypeCodes
        },
        JOB_CODES: state => { // 129 산업분류
            // let arr = null, text=null;

            // if (state.detailCodes.jobCodes !== null) {
            //     arr = state.detailCodes.jobCodes.reduce( (forward, it) => {
            //         switch (it.detailCode) {
            //             case '13': 
            //                 // 제조업
            //                 forward.push({detailCode: it.detailCode, detailName:'물건을 제조 및 생산 공장에서 종사'})
            //                 break;
            //             case '16':
            //                 // 건설업
            //                 forward.push({detailCode: it.detailCode, detailName:'건설현장에서 일일노동자로 종사'})
            //                 break;
            //             case '17':
            //                 // 도매 및 소매업
            //                 forward.push({detailCode: it.detailCode, detailName:'물건 떼다 판매하는 유통종사로 근무'})
            //                 break;
            //             case '18':
            //                 // 운수 및 창고업
            //                 forward.push({detailCode: it.detailCode, detailName:'운반하는 드라이버 또는 물류창고업 종사'})
            //                 break;
            //             case '19':
            //                 //  숙박 및 음식업점
            //                 forward.push({detailCode: it.detailCode, detailName:'주방 또는 서빙과 관련된 음식점에서 종사'})
            //                 break;
            //             case '20':
            //                 //  정보통신업
            //                 forward.push({detailCode: it.detailCode, detailName:'IT와 관련된 직종에서 종사'})
            //                 break;
            //             case '21':
            //                 //  금융 및 보험업
            //                 forward.push({detailCode: it.detailCode, detailName:'은행이나 금융, 보험 설계 또는 판매'})
            //                 break;
            //             case '22':
            //                 //  부동산업
            //                 forward.push({detailCode: it.detailCode, detailName:'부동산 중개업 또는 땅 투자 종사'})
            //                 break;
            //             case '26':
            //                 //  교육서비스업
            //                 forward.push({detailCode: it.detailCode, detailName:'교사, 강사, 교수 등 교육관련업 종사'})
            //                 break;
            //             case '26':
            //                 //  보건 및 사회복지 서비스업
            //                 forward.push({detailCode: it.detailCode, detailName:'사회복지 또는 보건과 관련 서비스업 종사'})
            //                 break;
            //         }
            //         return forward
            //     }, []);
            //     // init selected value is add
            //     arr.unshift({detailCode: 0, detailName: '시도 선택'})
            // } else {
            //     arr = [{detailCode: 0, detailName: '시도 선택'}]
            // }

            // return state.detailCodes.jobCodes = arr
            return state.detailCodes.jobCodes
        },
        CERTIFICATE_TYPE_CODES: state => { // 130 자격구분
            return state.detailCodes.certificateTypeCodes
        },
        ORGANDUTY_AREA_CODES: state => { // 131 기관직무분야
            return state.detailCodes.organDutyAreaCodes
        },
        CERTIFICATE_ITEMS_CODES: state => { // 132 자격종목코드
            return state.detailCodes.certificateItemsCodes
        },
        RETIREMENT_REASON_CODES: state => { // 143 퇴직사유코드
            let arr = null;

            if (state.detailCodes.retirementReasonCodes !== null) {
                arr = state.detailCodes.retirementReasonCodes.reduce((forward, it) => {
                    forward.push({ value: it.detailCode, text: it.detailName })
                    return forward
                }, [])
            } else {
                // arr = [{value: null, text: '사업자 업태 분류'}]
                arr = null
            }

            return arr
                // return state.detailCodes.retirementReasonCodes
        },
        REASON_CODES: state => { // 197 회원탈퇴사유
            return state.detailCodes.reasonCodes
        },
        PAY_METHOD_CODES: state => { // 210 납입방법코드
            return state.detailCodes.payMethodCodes
        },
        DEPOSIT_BANK_CODES: state => { // 227 납입은행코드
            return state.detailCodes.depositBankCodes
        },
        CHARGE_CREATE_STANDARD_CODES: state => { // 244 청구생성기준코드
            return state.detailCodes.chargeCreateStandardCodes
        },
        SMS_CATEGORY_CODES: state => { // 216 SMS카테고리코드
            return state.detailCodes.smsCategoryCodes
        },
        SMS_CATEGORY_FILTER: state => { // 216 SMS카테고리코드 필터용
            if(state.detailCodes.smsCategoryCodes) {
                let arr = [...state.detailCodes.smsCategoryCodes]
                arr.unshift({
                    detailName: '전체',
                    detailCode: '99'
                })
                return arr
            }
        },
        LONGTERMCARE_GRADE_CODES: state => { //250 장기요양등급코드
            return state.detailCodes.longtermcareGradeCodes
        },
        GUARIDAN_RELATIONSHIP_CODES: state => { //252 보호자관계코드
            return state.detailCodes.guardianRelationshipCodes
        },
        DEPUTY_RELATIONSHIP_CODES: state => { //253 대리인관계코드
            return state.detailCodes.deputyRelationshipCodes
        },
        PERSON_CHARGE_TYPE_CODES: state => { //256 본인부담금률
            return state.detailCodes.personChargeTypeCodes
        },
        OFFICE_CHECK_METHOD_TYPE_CODES: state => { // 258 출근체크방법구분코드
            return state.detailCodes.officeCheckMethodTypeCodes
        },
        CHECK_DEVICE_SETUP_ORGAN_TYPE_CODES: state => { //259 체크기기설치기관구분코드
            return state.detailCodes.checkDeviceSetupOrganTypeCodes
        },
        CAR_USAGE_TYPE_CODES: state => { // 262 차량용도
            return state.detailCodes.carUsageTypeCodes
        },
        CAR_PROSSESS_TYPE_CODES: state => { // 263 차량소유
            return state.detailCodes.carPossessTypeCodes
        },
        CAR_STATE_CODES: state => { // 264 차량상태
            return state.detailCodes.carStateCodes
        },
        CAR_MAINTENANCE_CODES: state => { // 265 차량정비구분
            return state.detailCodes.carMaintenanceTypeCodes
        },
        PAY_KIND_TYPE_CODES: state => { // 278 서비스 급여종류
            return state.detailCodes.payKindTypeCodes
        },
        WRITE_REASON_CODES: state => { // 307 급여제공계획서 작성사유
            return state.detailCodes.writeReasonCode
        },
        CONTRACT_STATE_CODES: state => { // 117 계약상태코드
            if (state.detailCodes.contractStateCodes) {
                state.detailCodes.contractStateCodes.unshift({ detailCode: null, detailName: '[계약]전체보기' })
                return state.detailCodes.contractStateCodes
            }
        },
        LEGEND_FORM_BOX_CODES: state => { // 218 범례서식함구분코드
            return state.detailCodes.legendFormBoxCodes
        },
        LEGEND_FORM_CLASS_CODES: state => { //219 범례서식분류코드
            return state.detailCodes.legendFormClassCodes
        },
        OPTION_SERVICE_TYPE_CODES: state => { //223 부가서비스구분코드
            return state.detailCodes.optionServiceTypeCodes
        },
        OPEN_SCOPE_CODES: state => { //231 SNS공개범위코드
            return state.detailCodes.openScopeCodes
        },
        REPORT_REASON_TYPE_CODES: state => { // 232 SNS신고이유구분코드
            return state.detailCodes.reportReasonTypeCodes
        },
        RECIPIENT_STATUS_CODES: state => { // 260 //수급자 상태코드
            let arr = null;

            if (state.detailCodes.recipientStatusCodes !== null) {
                arr = state.detailCodes.recipientStatusCodes.reduce((forward, it) => {
                    forward.push({ value: it.detailCode, text: it.detailName })
                    return forward
                }, [])
            } else {
                // arr = [{value: null, text: '사업자 업태 분류'}]
                arr = null
            }

            return arr
                // return state.detailCodes.recipientStatusCodes
        },
        RECIPIENT_CANCEL_REASON_CODES: state => {
            let arr = null;

            if (state.detailCodes.cancelReasonCodes !== null) {
                arr = state.detailCodes.cancelReasonCodes.reduce((forward, it) => {
                    forward.push({ value: it.detailCode, text: it.detailName })
                    return forward
                }, [])
            } else {
                // arr = [{value: null, text: '사업자 업태 분류'}]
                arr = null
            }

            return arr
                // return state.detailCodes.recipientStatusCodes
        },
        STAFF_SELECT_TYPE_CODES: state => { // 276 직원선택구분코드
            return state.detailCodes.staffSelectTypeCodes
        },
        CARE_SERVICE_TYPE_CODES: state => { // 298 요양보호사 급여유형코드
            let arr = null;

            if (state.detailCodes.careServiceTypeCodes !== null) {
                arr = state.detailCodes.careServiceTypeCodes.reduce((forward, it) => {
                    forward.push({ value: it.detailCode, text: it.detailName })
                    return forward
                }, [])
            } else {
                // arr = [{value: null, text: '사업자 업태 분류'}]
                arr = null
            }

            return arr
        },
        LTCARE_SERVICE_TYPE_CODES: state => { // 368 장기요양서비스유형코드
            return state.detailCodes.ltcareServiceTypeCodes
        },
        HOME_SERVICE_TYPE_CODES: state => { //229 재가서비스유형코드
            return state.detailCodes.homeServiceTypeCodes
        },
        VACATION_TYPE_CODES: state => { // 233 휴가분류코드
            return state.detailCodes.vacationTypeCodes
        },
        DISTRESS_TYPE_CODES: state => { // 308 고충상담구분코드
            return state.detailCodes.distressTypeCodes
        },
        HOLIDAY_TYPE_CODES: state => { // 344 휴일유형코드
            return state.detailCodes.holidayTypeCodes
        },
        EVAL_LOCATION_TYPE_CODES: state => { // 387 검사장소구분코드
            return state.detailCodes.evalLocationTypeCodes
        },
        SUADE_CONTRACT_POST_PONE_REASON_CODES: state => { // 293 수급보류 코드
            return state.detailCodes.suadeContractPostponeReasonCodes
        },
        FAMILY_CARE_RELATION_CODES: state => { // 284 가족요양관계코드
            return state.detailCodes.familyCareRelationCodes
        },
        INQUIRY_CODES: state => { // 310 서비스문의코드
            return state.detailCodes.inquiryCodes
        },
        BUSINESS_TYPE_CODES: state => { // 104 사업자유형
            return state.detailCodes.businessTypeCodes
        },
        SIDO_CODES: state => { // 106 시도코드
            return state.detailCodes.sidoCodes
        },
        BUSINESS_CONDITION_CODES: state => { // 107 사업업태
            return state.detailCodes.businessConditionCodes
        },
        BUSINESS_EVENT_CODES: state => { // 108 사업종목
            return state.detailCodes.busunessEventCodes
        },
        ITCARE_AGENCY_TYPE_CODES: state => { // 291 장기요양기관유형
            return state.detailCodes.itcareAgencyTypeCodes
        },
        ACTIVE_STATE_CODES: state => { // 245 활동상태
            return state.detailCodes.activeStateCodes
        },
        SNS_ATTEND_STATE_CODES: state => { // 회의참석코드
            return state.detailCodes.snsAttendStateCodes
        },
        SALARY_NUMBER_CODES: state => { // 311 수가코드
            return state.detailCodes.salaryNumberCodes
        },
        ACCOUNT_TYPE_CODES: state => { // 316 계좌구분코드
            return state.detailCodes.accountTypeCodes
        },
        DEPOSIT_OWNER_TYPE_CODES: state => { // 315 예금주구분코드
            return state.detailCodes.depositOwnerTypeCodes
        },
        APPROVAL_LINE_TYPE_CODES: state => { // 327 결재선유형코드
            return state.detailCodes.approvalLineTypeCodes
        },
        APPROVAL_METHOD_TYPE_CODES: state => { // 328 결재방법유형코드
            return state.detailCodes.approvalMethodTypeCodes
        },
        APPROVAL_AGREE_PROGRESS_CODES: state => { // 329 결재합의자진행방식코드
            return state.detailCodes.approvalAgreeProgressCodes
        },
        APPROVAL_INSERVICE_LIFE_TYPE_CODES: state => { // 330 보존연한구분코드
            return state.detailCodes.approvalInserviceLifeTypeCodes
        },
        APPROVAL_IMPORTANT_TYPE_CODES: state => { // 332 중요도구분코드
            return state.detailCodes.approvalImportantTypeCodes
        },
        VACATION_USE_METHOD_CODES: state => { // 353 휴가사용방법코드
            return state.detailCodes.vacationUseMethodCodes
        },
        SALARY_FREQUENCY_TYPE_CODES: state => { // 376 급여횟수구분코드
            return state.detailCodes.salaryFrequencyTypeCodes
        },
        MEDICINE_TYPE_CODES: state => { // 347 구분코드
            return state.detailCodes.medicineTypeCodes
        },
        USE_METHOD_CODES: state => { // 348 사용방식코드
            return state.detailCodes.useMethodCodes
        },
        DISINFECT_METHOD_CODES: state => { // 349 소독방법코드
            return state.detailCodes.disinfectMethodCodes
        },
        DOSAGE_METHOD_CODES: state => { // 350 투약방법
            return state.detailCodes.dosageMethodCodes
        },
        KEEP_METHOD_CODES: state => { // 351 보관방법
            return state.detailCodes.keepMethodCodes
        },
        COUNSEL_METHOD_CODES: state => { // 406 상담방법
            return state.detailCodes.counselMethodCodes
        },
        COUNSEL_CLASS_TYPE_CODES: state => { // 407 상담분류코드
            return state.detailCodes.counselClassTypeCodes
        },
        VACATION_APPLY_STANDARD_CODES: state => { // 336 휴가적용기준코드
            return state.detailCodes.vacationApplyStandardCodes
        },
        ANNUAL_CALC_DECIMAL_CODES: state => { // 337 연차계산소수자리
            return state.detailCodes.annualCalcDecimalCodes
        },
        ANNUAL_PROMOTION_CODES: state => { // 339 연차촉진코드
            return state.detailCodes.annualPromotionCodes
        },
        INFLOW_ROUTE_CODES: state => { // 356 유입경로
            return state.detailCodes.inflowRouteCodes
        },
        PAY_CANCEL_REFUND_METHOD_CODES: state => { // 396 취소환불방법코드
            return state.detailCodes.payCancelRefundMethodCodes
        },
        SEND_METHOD_TYPE_CODES: state => { // 398 전당방법코드
            return state.detailCodes.sendMethodTypeCodes
        },
        MEETING_TYPE_CODES: state => { // 473 회의록구분코드
            return state.detailCodes.meetingTypeCodes
        },
        OPEN_SCOPE_RANGE_CALENDAR_CODES: state => {

            let arr = null;

            if (state.detailCodes.openRangeVisibilityCodes !== null) {
                arr = state.detailCodes.openRangeVisibilityCodes.reduce((forward, it) => {
                    if (it.detailCode !== 'default' && it.detailCode !== 'confidential') {
                        forward.push({ value: it.detailCode, text: it.detailName })
                    }
                    return forward
                }, [])
            } else {
                // arr = [{value: null, text: '사업자 업태 분류'}]
                arr = null
            }

            return arr

            return state.detailCodes.openRangeVisibilityCodes
        },
        KOREA_EMPLOY_CLASS_CODES: state => {
            if (state.detailCodes.koreaEmployClassCodes) {
                state.detailCodes.koreaEmployClassCodes.forEach(item => {
                    item['text'] = `${item.detailCode} - ${item.detailName}`
                })
            }
            return state.detailCodes.koreaEmployClassCodes
        },
        MESSAGE_REPLACE_CODES: state => { // 470 메시지치환코드
            return state.detailCodes.messageReplaceCodes
        }

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/detailCodes.js